export default "__VITE_ASSET__$FrVpEVV__"